var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNewyork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 205.664,
    height: 165.674,
    viewBox: "0 0 205.664 165.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#f0a022}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_newyork",
    transform: "translate(-5 -966.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4255",
    d: "M10.713 1024.969a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4255",
    transform: "translate(0 71.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4256",
    d: "M14.213 1021.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4256",
    transform: "translate(4.498 67.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4257",
    d: "M14.213 1024.969a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4257",
    transform: "translate(4.498 71.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4258",
    d: "M14.213 1028.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4258",
    transform: "translate(4.498 76.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4259",
    d: "M17.713 1007.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4259",
    transform: "translate(8.996 49.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4260",
    d: "M17.713 1010.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4260",
    transform: "translate(8.996 53.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4261",
    d: "M17.713 1014.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4261",
    transform: "translate(8.996 58.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4262",
    d: "M17.713 1017.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4262",
    transform: "translate(8.996 62.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4263",
    d: "M17.713 1021.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4263",
    transform: "translate(8.996 67.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4264",
    d: "M17.713 1024.969a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4264",
    transform: "translate(8.996 71.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4265",
    d: "M17.713 1028.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4265",
    transform: "translate(8.996 76.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4266",
    d: "M21.213 1007.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4266",
    transform: "translate(13.494 49.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4267",
    d: "M21.213 1010.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4267",
    transform: "translate(13.494 53.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4268",
    d: "M21.213 1014.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4268",
    transform: "translate(13.494 58.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4269",
    d: "M21.213 1017.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4269",
    transform: "translate(13.494 62.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4270",
    d: "M21.213 1021.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4270",
    transform: "translate(13.494 67.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4271",
    d: "M21.213 1024.969a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4271",
    transform: "translate(13.494 71.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4272",
    d: "M21.213 1028.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4272",
    transform: "translate(13.494 76.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4273",
    d: "M24.713 1003.969a2.856 2.856 0 1 1-2.856-2.857 2.856 2.856 0 0 1 2.856 2.857z",
    className: "cls-1",
    "data-name": "Path 4273",
    transform: "translate(17.992 44.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4274",
    d: "M24.713 1007.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4274",
    transform: "translate(17.992 49.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4275",
    d: "M24.713 1010.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4275",
    transform: "translate(17.992 53.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4276",
    d: "M24.713 1014.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4276",
    transform: "translate(17.992 58.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4277",
    d: "M24.713 1017.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4277",
    transform: "translate(17.992 62.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4278",
    d: "M24.713 1021.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4278",
    transform: "translate(17.992 67.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4279",
    d: "M24.713 1024.969a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4279",
    transform: "translate(17.992 71.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4280",
    d: "M28.213 1003.969a2.856 2.856 0 1 1-2.856-2.857 2.856 2.856 0 0 1 2.856 2.857z",
    className: "cls-1",
    "data-name": "Path 4280",
    transform: "translate(22.49 44.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4281",
    d: "M28.213 1007.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4281",
    transform: "translate(22.49 49.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4282",
    d: "M28.213 1010.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4282",
    transform: "translate(22.49 53.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4283",
    d: "M28.213 1014.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4283",
    transform: "translate(22.49 58.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4284",
    d: "M28.213 1017.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4284",
    transform: "translate(22.49 62.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4285",
    d: "M28.213 1021.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4285",
    transform: "translate(22.49 67.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4286",
    d: "M28.213 1024.969a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4286",
    transform: "translate(22.49 71.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4287",
    d: "M31.713 1003.969a2.856 2.856 0 1 1-2.856-2.857 2.856 2.856 0 0 1 2.856 2.857z",
    className: "cls-1",
    "data-name": "Path 4287",
    transform: "translate(26.988 44.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4288",
    d: "M31.713 1007.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4288",
    transform: "translate(26.988 49.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4289",
    d: "M31.713 1010.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4289",
    transform: "translate(26.988 53.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4290",
    d: "M31.713 1014.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4290",
    transform: "translate(26.988 58.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4291",
    d: "M31.713 1017.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4291",
    transform: "translate(26.988 62.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4292",
    d: "M31.713 1021.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4292",
    transform: "translate(26.988 67.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4293",
    d: "M31.713 1024.969a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4293",
    transform: "translate(26.988 71.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4294",
    d: "M35.213 1003.969a2.856 2.856 0 1 1-2.856-2.857 2.856 2.856 0 0 1 2.856 2.857z",
    className: "cls-1",
    "data-name": "Path 4294",
    transform: "translate(31.486 44.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4295",
    d: "M35.213 1007.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4295",
    transform: "translate(31.486 49.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4296",
    d: "M35.213 1010.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4296",
    transform: "translate(31.486 53.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4297",
    d: "M35.213 1014.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4297",
    transform: "translate(31.486 58.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4298",
    d: "M35.213 1017.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4298",
    transform: "translate(31.486 62.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4299",
    d: "M35.213 1021.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4299",
    transform: "translate(31.486 67.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4300",
    d: "M35.213 1024.969a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4300",
    transform: "translate(31.486 71.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4301",
    d: "M38.713 1003.969a2.856 2.856 0 1 1-2.856-2.857 2.856 2.856 0 0 1 2.856 2.857z",
    className: "cls-1",
    "data-name": "Path 4301",
    transform: "translate(35.984 44.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4302",
    d: "M38.713 1007.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4302",
    transform: "translate(35.984 49.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4303",
    d: "M38.713 1010.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4303",
    transform: "translate(35.984 53.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4304",
    d: "M38.713 1014.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4304",
    transform: "translate(35.984 58.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4305",
    d: "M38.713 1017.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4305",
    transform: "translate(35.984 62.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4306",
    d: "M38.713 1021.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4306",
    transform: "translate(35.984 67.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4307",
    d: "M42.213 989.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4307",
    transform: "translate(40.482 26.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4308",
    d: "M42.213 1000.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4308",
    transform: "translate(40.482 40.482)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4309",
    d: "M42.213 1003.969a2.856 2.856 0 1 1-2.856-2.857 2.856 2.856 0 0 1 2.856 2.857z",
    className: "cls-1",
    "data-name": "Path 4309",
    transform: "translate(40.482 44.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4310",
    d: "M42.213 1007.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4310",
    transform: "translate(40.482 49.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4311",
    d: "M42.213 1010.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4311",
    transform: "translate(40.482 53.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4312",
    d: "M42.213 1014.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4312",
    transform: "translate(40.482 58.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4313",
    d: "M42.213 1017.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4313",
    transform: "translate(40.482 62.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4314",
    d: "M42.213 1021.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4314",
    transform: "translate(40.482 67.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4315",
    d: "M45.713 982.968a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4315",
    transform: "translate(44.98 17.992)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4316",
    d: "M45.713 986.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4316",
    transform: "translate(44.98 22.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4317",
    d: "M45.713 989.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4317",
    transform: "translate(44.98 26.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4318",
    d: "M45.713 993.468a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4318",
    transform: "translate(44.98 31.486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4319",
    d: "M45.713 996.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4319",
    transform: "translate(44.98 35.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4320",
    d: "M45.713 1000.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4320",
    transform: "translate(44.98 40.482)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4321",
    d: "M45.713 1003.969a2.856 2.856 0 1 1-2.856-2.857 2.856 2.856 0 0 1 2.856 2.857z",
    className: "cls-1",
    "data-name": "Path 4321",
    transform: "translate(44.98 44.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4322",
    d: "M45.713 1007.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4322",
    transform: "translate(44.98 49.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4323",
    d: "M45.713 1010.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4323",
    transform: "translate(44.98 53.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4324",
    d: "M45.713 1014.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4324",
    transform: "translate(44.98 58.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4325",
    d: "M45.713 1017.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4325",
    transform: "translate(44.98 62.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4326",
    d: "M45.713 1021.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4326",
    transform: "translate(44.98 67.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4327",
    d: "M49.213 979.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4327",
    transform: "translate(49.478 13.494)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4328",
    d: "M49.213 982.968a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4328",
    transform: "translate(49.478 17.992)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4329",
    d: "M49.213 986.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4329",
    transform: "translate(49.478 22.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4330",
    d: "M49.213 989.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4330",
    transform: "translate(49.478 26.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4331",
    d: "M49.213 993.468a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4331",
    transform: "translate(49.478 31.486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4332",
    d: "M49.213 996.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4332",
    transform: "translate(49.478 35.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4333",
    d: "M49.213 1000.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4333",
    transform: "translate(49.478 40.482)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4334",
    d: "M49.213 1003.969a2.856 2.856 0 1 1-2.856-2.857 2.856 2.856 0 0 1 2.856 2.857z",
    className: "cls-1",
    "data-name": "Path 4334",
    transform: "translate(49.478 44.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4335",
    d: "M49.213 1007.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4335",
    transform: "translate(49.478 49.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4336",
    d: "M49.213 1010.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4336",
    transform: "translate(49.478 53.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4337",
    d: "M49.213 1014.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4337",
    transform: "translate(49.478 58.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4338",
    d: "M49.213 1017.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4338",
    transform: "translate(49.478 62.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4339",
    d: "M49.213 1021.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4339",
    transform: "translate(49.478 67.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4340",
    d: "M52.713 975.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4340",
    transform: "translate(53.976 8.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4341",
    d: "M52.713 979.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4341",
    transform: "translate(53.976 13.494)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4342",
    d: "M52.713 982.968a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4342",
    transform: "translate(53.976 17.992)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4343",
    d: "M52.713 986.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4343",
    transform: "translate(53.976 22.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4344",
    d: "M52.713 989.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4344",
    transform: "translate(53.976 26.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4345",
    d: "M52.713 993.468a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4345",
    transform: "translate(53.976 31.486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4346",
    d: "M52.713 996.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4346",
    transform: "translate(53.976 35.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4347",
    d: "M52.713 1000.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4347",
    transform: "translate(53.976 40.482)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4348",
    d: "M52.713 1003.969a2.856 2.856 0 1 1-2.856-2.857 2.856 2.856 0 0 1 2.856 2.857z",
    className: "cls-1",
    "data-name": "Path 4348",
    transform: "translate(53.976 44.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4349",
    d: "M52.713 1007.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4349",
    transform: "translate(53.976 49.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4350",
    d: "M52.713 1010.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4350",
    transform: "translate(53.976 53.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4351",
    d: "M52.713 1014.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4351",
    transform: "translate(53.976 58.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4352",
    d: "M52.713 1017.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4352",
    transform: "translate(53.976 62.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4353",
    d: "M56.213 972.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4353",
    transform: "translate(58.475 4.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4354",
    d: "M56.213 975.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4354",
    transform: "translate(58.475 8.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4355",
    d: "M56.213 979.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4355",
    transform: "translate(58.475 13.494)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4356",
    d: "M56.213 982.968a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4356",
    transform: "translate(58.475 17.992)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4357",
    d: "M56.213 986.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4357",
    transform: "translate(58.475 22.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4358",
    d: "M56.213 989.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4358",
    transform: "translate(58.475 26.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4359",
    d: "M56.213 993.468a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4359",
    transform: "translate(58.475 31.486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4360",
    d: "M56.213 996.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4360",
    transform: "translate(58.475 35.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4361",
    d: "M56.213 1000.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4361",
    transform: "translate(58.475 40.482)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4362",
    d: "M56.213 1003.969a2.856 2.856 0 1 1-2.856-2.857 2.856 2.856 0 0 1 2.856 2.857z",
    className: "cls-1",
    "data-name": "Path 4362",
    transform: "translate(58.475 44.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4363",
    d: "M56.213 1007.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4363",
    transform: "translate(58.475 49.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4364",
    d: "M56.213 1010.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4364",
    transform: "translate(58.475 53.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4365",
    d: "M56.213 1014.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4365",
    transform: "translate(58.475 58.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4366",
    d: "M56.213 1017.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4366",
    transform: "translate(58.475 62.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4367",
    d: "M59.713 972.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4367",
    transform: "translate(62.973 4.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4368",
    d: "M59.713 975.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4368",
    transform: "translate(62.973 8.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4369",
    d: "M59.713 979.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4369",
    transform: "translate(62.973 13.494)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4370",
    d: "M59.713 982.968a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4370",
    transform: "translate(62.973 17.992)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4371",
    d: "M59.713 986.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4371",
    transform: "translate(62.973 22.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4372",
    d: "M59.713 989.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4372",
    transform: "translate(62.973 26.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4373",
    d: "M59.713 993.468a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4373",
    transform: "translate(62.973 31.486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4374",
    d: "M59.713 996.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4374",
    transform: "translate(62.973 35.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4375",
    d: "M59.713 1000.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4375",
    transform: "translate(62.973 40.482)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4376",
    d: "M59.713 1003.969a2.856 2.856 0 1 1-2.856-2.857 2.856 2.856 0 0 1 2.856 2.857z",
    className: "cls-1",
    "data-name": "Path 4376",
    transform: "translate(62.973 44.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4377",
    d: "M59.713 1007.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4377",
    transform: "translate(62.973 49.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4378",
    d: "M59.713 1010.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4378",
    transform: "translate(62.973 53.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4379",
    d: "M59.713 1014.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4379",
    transform: "translate(62.973 58.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4380",
    d: "M59.713 1017.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4380",
    transform: "translate(62.973 62.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4381",
    d: "M63.213 972.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4381",
    transform: "translate(67.471 4.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4382",
    d: "M63.213 975.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4382",
    transform: "translate(67.471 8.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4383",
    d: "M63.213 979.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4383",
    transform: "translate(67.471 13.494)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4384",
    d: "M63.213 982.968a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4384",
    transform: "translate(67.471 17.992)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4385",
    d: "M63.213 986.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4385",
    transform: "translate(67.471 22.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4386",
    d: "M63.213 989.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4386",
    transform: "translate(67.471 26.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4387",
    d: "M63.213 993.468a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4387",
    transform: "translate(67.471 31.486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4388",
    d: "M63.213 996.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4388",
    transform: "translate(67.471 35.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4389",
    d: "M63.213 1000.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4389",
    transform: "translate(67.471 40.482)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4390",
    d: "M63.213 1003.969a2.856 2.856 0 1 1-2.856-2.857 2.856 2.856 0 0 1 2.856 2.857z",
    className: "cls-1",
    "data-name": "Path 4390",
    transform: "translate(67.471 44.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4391",
    d: "M63.213 1007.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4391",
    transform: "translate(67.471 49.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4392",
    d: "M63.213 1010.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4392",
    transform: "translate(67.471 53.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4393",
    d: "M63.213 1014.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4393",
    transform: "translate(67.471 58.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4394",
    d: "M63.213 1017.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4394",
    transform: "translate(67.471 62.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4395",
    d: "M63.213 1021.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4395",
    transform: "translate(67.471 67.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4396",
    d: "M66.713 972.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4396",
    transform: "translate(71.969 4.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4397",
    d: "M66.713 975.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4397",
    transform: "translate(71.969 8.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4398",
    d: "M66.713 979.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4398",
    transform: "translate(71.969 13.494)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4399",
    d: "M66.713 982.968a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4399",
    transform: "translate(71.969 17.992)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4400",
    d: "M66.713 986.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4400",
    transform: "translate(71.969 22.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4401",
    d: "M66.713 989.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4401",
    transform: "translate(71.969 26.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4402",
    d: "M66.713 993.468a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4402",
    transform: "translate(71.969 31.486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4403",
    d: "M66.713 996.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4403",
    transform: "translate(71.969 35.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4404",
    d: "M66.713 1000.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4404",
    transform: "translate(71.969 40.482)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4405",
    d: "M66.713 1003.969a2.856 2.856 0 1 1-2.856-2.857 2.856 2.856 0 0 1 2.856 2.857z",
    className: "cls-1",
    "data-name": "Path 4405",
    transform: "translate(71.969 44.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4406",
    d: "M66.713 1007.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4406",
    transform: "translate(71.969 49.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4407",
    d: "M66.713 1010.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4407",
    transform: "translate(71.969 53.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4408",
    d: "M66.713 1014.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4408",
    transform: "translate(71.969 58.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4409",
    d: "M66.713 1017.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4409",
    transform: "translate(71.969 62.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4410",
    d: "M66.713 1021.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4410",
    transform: "translate(71.969 67.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4411",
    d: "M66.713 1024.969a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4411",
    transform: "translate(71.969 71.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4412",
    d: "M70.213 968.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4412",
    transform: "translate(76.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4413",
    d: "M70.213 972.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4413",
    transform: "translate(76.467 4.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4414",
    d: "M70.213 975.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4414",
    transform: "translate(76.467 8.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4415",
    d: "M70.213 979.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4415",
    transform: "translate(76.467 13.494)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4416",
    d: "M70.213 982.968a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4416",
    transform: "translate(76.467 17.992)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4417",
    d: "M70.213 986.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4417",
    transform: "translate(76.467 22.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4418",
    d: "M70.213 989.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4418",
    transform: "translate(76.467 26.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4419",
    d: "M70.213 993.468a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4419",
    transform: "translate(76.467 31.486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4420",
    d: "M70.213 996.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4420",
    transform: "translate(76.467 35.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4421",
    d: "M70.213 1000.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4421",
    transform: "translate(76.467 40.482)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4422",
    d: "M70.213 1003.969a2.856 2.856 0 1 1-2.856-2.857 2.856 2.856 0 0 1 2.856 2.857z",
    className: "cls-1",
    "data-name": "Path 4422",
    transform: "translate(76.467 44.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4423",
    d: "M70.213 1007.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4423",
    transform: "translate(76.467 49.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4424",
    d: "M70.213 1010.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4424",
    transform: "translate(76.467 53.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4425",
    d: "M70.213 1014.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4425",
    transform: "translate(76.467 58.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4426",
    d: "M70.213 1017.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4426",
    transform: "translate(76.467 62.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4427",
    d: "M70.213 1021.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4427",
    transform: "translate(76.467 67.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4428",
    d: "M70.213 1024.969a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4428",
    transform: "translate(76.467 71.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4429",
    d: "M70.213 1028.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4429",
    transform: "translate(76.467 76.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4430",
    d: "M73.713 968.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4430",
    transform: "translate(80.965)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4431",
    d: "M73.713 972.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4431",
    transform: "translate(80.965 4.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4432",
    d: "M73.713 975.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4432",
    transform: "translate(80.965 8.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4433",
    d: "M73.713 979.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4433",
    transform: "translate(80.965 13.494)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4434",
    d: "M73.713 982.968a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4434",
    transform: "translate(80.965 17.992)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4435",
    d: "M73.713 986.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4435",
    transform: "translate(80.965 22.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4436",
    d: "M73.713 989.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4436",
    transform: "translate(80.965 26.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4437",
    d: "M73.713 993.468a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4437",
    transform: "translate(80.965 31.486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4438",
    d: "M73.713 996.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4438",
    transform: "translate(80.965 35.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4439",
    d: "M73.713 1000.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4439",
    transform: "translate(80.965 40.482)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4440",
    d: "M73.713 1003.969a2.856 2.856 0 1 1-2.856-2.857 2.856 2.856 0 0 1 2.856 2.857z",
    className: "cls-1",
    "data-name": "Path 4440",
    transform: "translate(80.965 44.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4441",
    d: "M73.713 1007.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4441",
    transform: "translate(80.965 49.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4442",
    d: "M73.713 1010.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4442",
    transform: "translate(80.965 53.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4443",
    d: "M73.713 1014.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4443",
    transform: "translate(80.965 58.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4444",
    d: "M73.713 1017.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4444",
    transform: "translate(80.965 62.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4445",
    d: "M73.713 1021.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4445",
    transform: "translate(80.965 67.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4446",
    d: "M73.713 1024.969a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4446",
    transform: "translate(80.965 71.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4447",
    d: "M73.713 1028.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4447",
    transform: "translate(80.965 76.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4448",
    d: "M77.213 986.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4448",
    transform: "translate(85.463 22.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4449",
    d: "M77.213 989.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4449",
    transform: "translate(85.463 26.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4450",
    d: "M77.213 993.468a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4450",
    transform: "translate(85.463 31.486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4451",
    d: "M77.213 996.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4451",
    transform: "translate(85.463 35.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4452",
    d: "M77.213 1000.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4452",
    transform: "translate(85.463 40.482)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4453",
    d: "M77.213 1003.969a2.856 2.856 0 1 1-2.856-2.857 2.856 2.856 0 0 1 2.856 2.857z",
    className: "cls-1",
    "data-name": "Path 4453",
    transform: "translate(85.463 44.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4454",
    d: "M77.213 1007.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4454",
    transform: "translate(85.463 49.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4455",
    d: "M77.213 1010.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4455",
    transform: "translate(85.463 53.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4456",
    d: "M77.213 1014.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4456",
    transform: "translate(85.463 58.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4457",
    d: "M77.213 1017.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4457",
    transform: "translate(85.463 62.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4458",
    d: "M77.213 1021.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4458",
    transform: "translate(85.463 67.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4459",
    d: "M77.213 1024.969a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4459",
    transform: "translate(85.463 71.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4460",
    d: "M77.213 1028.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4460",
    transform: "translate(85.463 76.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4461",
    d: "M80.713 993.468a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4461",
    transform: "translate(89.961 31.486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4462",
    d: "M80.713 996.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4462",
    transform: "translate(89.961 35.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4463",
    d: "M80.713 1000.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4463",
    transform: "translate(89.961 40.482)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4464",
    d: "M80.713 1003.969a2.856 2.856 0 1 1-2.856-2.857 2.856 2.856 0 0 1 2.856 2.857z",
    className: "cls-1",
    "data-name": "Path 4464",
    transform: "translate(89.961 44.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4465",
    d: "M80.713 1007.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4465",
    transform: "translate(89.961 49.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4466",
    d: "M80.713 1010.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4466",
    transform: "translate(89.961 53.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4467",
    d: "M80.713 1014.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4467",
    transform: "translate(89.961 58.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4468",
    d: "M80.713 1017.969a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4468",
    transform: "translate(89.961 62.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4469",
    d: "M80.713 1021.469a2.856 2.856 0 1 1-2.856-2.856 2.856 2.856 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4469",
    transform: "translate(89.961 67.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4470",
    d: "M80.713 1024.969a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4470",
    transform: "translate(89.961 71.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4471",
    d: "M80.713 1028.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4471",
    transform: "translate(89.961 76.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4472",
    d: "M80.713 1031.969a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4472",
    transform: "translate(89.961 80.965)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4473",
    d: "M80.713 1035.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4473",
    transform: "translate(89.961 85.463)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4474",
    d: "M80.713 1038.969a2.856 2.856 0 1 1-2.856-2.857 2.857 2.857 0 0 1 2.856 2.857z",
    className: "cls-1",
    "data-name": "Path 4474",
    transform: "translate(89.961 89.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4475",
    d: "M84.213 1031.969a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4475",
    transform: "translate(94.459 80.965)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4476",
    d: "M84.213 1035.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4476",
    transform: "translate(94.459 85.463)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4477",
    d: "M87.713 1028.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4477",
    transform: "translate(98.957 76.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4478",
    d: "M87.713 1031.969a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4478",
    transform: "translate(98.957 80.965)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4479",
    d: "M87.713 1035.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4479",
    transform: "translate(98.957 85.463)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4480",
    d: "M91.213 1028.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4480",
    transform: "translate(103.455 76.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4481",
    d: "M91.213 1031.969a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4481",
    transform: "translate(103.455 80.965)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4482",
    d: "M91.213 1035.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4482",
    transform: "translate(103.455 85.463)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4483",
    d: "M94.713 1028.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4483",
    transform: "translate(107.953 76.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4484",
    d: "M94.713 1031.969a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4484",
    transform: "translate(107.953 80.965)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4485",
    d: "M98.213 1028.469a2.856 2.856 0 1 1-2.856-2.856 2.857 2.857 0 0 1 2.856 2.856z",
    className: "cls-1",
    "data-name": "Path 4485",
    transform: "translate(112.451 76.467)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewyork);
export default __webpack_public_path__ + "static/media/icon-newyork.3b9dd371f2c58948d7a61d9bf5eb669b.svg";
export { ForwardRef as ReactComponent };